import React, { FC } from 'react';

import Schema from '../../../../../../lib/paths/verwendungsnachweis_FULL_Paths.json';
import { useApplication } from '../../../../../../context/ApplicationContext';
import { Typography } from '@mui/material';
import CreateForm from '../../../../../../components/ui-component/form-component/create-form/CreateForm';
import { concat } from 'lodash';
import { NonRequired } from '../../../../../../lib/validation/ValidationTypes';
const P = Schema.attributes;

const AnlagenVN: FC<{}> = () => {
	const { application, setApplicationProperty, readOnly } = useApplication();
	return (
		<>
			<Typography variant="h3">Anlagen</Typography>
			<CreateForm
				formStruc={strucAnlagenVN()}
				formValues={application}
				updateFormValuesFunc={setApplicationProperty}
				readOnly={readOnly}
			/>
		</>
	);
};
export default AnlagenVN;
const strucAnlagenVN = () => {
	return [
		{
			fields: [P.Dokumente_Verausgabung_Zahlenmaessiger_Nachweis, P.Dokumente_Verausgabung_Belegliste],
			userProps: { direction: 'column', columnToDivide: 2 },
		},
		{
			fields: [
				{
					...P.Dokumente_Verausgabung_Sonstige_Anlagen,
					type: 'componentMedia',
					fieldType: 'componentMedia',
					validation: [{ validateFunction: NonRequired }],
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
};

export const GetAnlagenFormStrucVN = () => {
	return concat(strucAnlagenVN());
};
